import { ISODate } from '../../commonv3/types/dates';
import { EntranceFeeItemId } from '../../commonv3/types/entranceFees';
import { MembershipItemId } from '../../commonv3/types/membershipPlans';
import { MembershipItemIndexView } from './membershipPlans';
import { EntranceFeeShowView } from './entranceFees';

export type ApplicationPageId = number;
export type ApplicationPageKey = string;
export const MULTICREATOR_APPLICATION_PAGE_KEY = 'multicreator';
export const BEAUTY_APPLICATION_PAGE_KEY = 'beauty';

export type ApplicationPage = {
    id: ApplicationPageId;
    name: string;
    entrance_fee_item_id: EntranceFeeItemId;
    membership_item_id: MembershipItemId;
    entrance_fee_item?: EntranceFeeShowView;
    membership_item: MembershipItemIndexView;
    renewable: boolean;
    page_key: ApplicationPageKey;
    effective_at: ISODate;
    expires_at: ISODate;
    fixed_effective_dates: ISODate[];
    service_agreement_key: string;
    // このページに現在のユーザが応募資格を持つかを返す
    qualified: boolean;
};
